import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Download } from 'lucide-react';

// Stable public URL for the current IFU: nursetechmedical.com/ifu
// To publish a new IFU revision, replace public/resources/Cordflex-IFU.pdf (currently QSL-001 Rev 1).
const IFU_PATH = '/resources/Cordflex-IFU.pdf';

const IFUPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        <div className="container mx-auto px-4 py-16 max-w-4xl">
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#214140' }}>
            Cordflex® Instructions for Use
          </h1>
          <p className="text-gray-600 mb-6">
            Read the full Instructions for Use before using Cordflex. Questions or product issues:
            quality[at]nursetechmedical.com.
          </p>
          <Button
            className="mb-8 px-6 py-3 font-semibold hover:opacity-90 transition-opacity duration-200"
            style={{ backgroundColor: '#214140', color: 'white' }}
            onClick={() => window.open(IFU_PATH, '_blank', 'noopener')}
          >
            <Download className="h-5 w-5 mr-2" />
            Open IFU (PDF)
          </Button>
          <iframe
            src={IFU_PATH}
            title="Cordflex Instructions for Use"
            className="w-full border rounded-lg"
            style={{ height: '80vh' }}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default IFUPage;
